/* ABUBA PDP buybox layer (Phase 1B). Scoped to the three ABUBA PDPs; does not edit main-product.liquid.
   - Selected-size line under the Size picker (with link to #abuba-quick-size and, since B1, a "How to measure" link to /pages/abuba-size-guide)
   - Experimental mobile sticky Add to Cart bar that proxies the real Add to Cart button
   - Availability hint when the chosen Size + Color pair does not exist (never changes the selection)
   - Size must be chosen first: without a valid ?variant= no size shows as selected and Add to Cart (+ sticky) stay disabled
     until the shopper picks one. The default variant stays checked internally, so Dawn's variant logic is untouched.
   - A missing Size + Color pair never shows the last valid variant's price */
(function () {
  if (window.__abubaBuybox) return;
  window.__abubaBuybox = true;

  var cfgEl = document.querySelector('[data-abuba-buybox]');
  var info = document.querySelector('product-info');
  if (!cfgEl || !info) return;

  var showNote = cfgEl.dataset.sizeNote === 'true';
  var sticky = document.querySelector('[data-abuba-sticky]');
  var noteEl = null;
  var SELECT_SIZE = 'Select size';
  var urlVariantId = null;
  try { urlVariantId = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
  var sizeRequired = false;
  var changeSeen = false;
  var sizeChosenByShopper = false;

  function sizeGroup() {
    var groups = info.querySelectorAll('variant-selects .product-form__input');
    for (var i = 0; i < groups.length; i++) {
      var lg = groups[i].querySelector('legend, label.form__label');
      if (lg && /^size\b/i.test(lg.textContent.trim())) return groups[i];
    }
    return null;
  }
  sizeRequired = !!sizeGroup() && !urlVariantId;

  function applySizeRequired() {
    var g = sizeGroup();
    if (g) g.setAttribute('data-abuba-size-group', '');
    if (sizeRequired) info.setAttribute('data-abuba-size-required', '');
    else info.removeAttribute('data-abuba-size-required');
    if (!sizeRequired) return;
    /* the crossed-out look on the other option reflects a size the shopper has not chosen yet */
    info.querySelectorAll('variant-selects input[type="radio"].disabled').forEach(function (r) { r.classList.remove('disabled'); });
    var b = mainBtn();
    if (b) {
      b.disabled = true;
      var lbl = b.querySelector('span') || b;
      if (lbl.textContent.trim() !== SELECT_SIZE) lbl.textContent = SELECT_SIZE;
    }
  }

  function mainBtn() { return info.querySelector('product-form button[name="add"]'); }

  function selected() {
    var out = [];
    info.querySelectorAll('variant-selects .product-form__input').forEach(function (grp) {
      var legend = grp.querySelector('legend, label.form__label');
      var checked = grp.querySelector('input[type="radio"]:checked');
      var sel = grp.querySelector('select');
      var value = checked ? checked.value : sel ? sel.value : '';
      if (legend && value) out.push({ name: legend.textContent.trim(), value: value });
    });
    return out;
  }

  function ensureNote() {
    if (!showNote) return;
    var first = info.querySelector('variant-selects .product-form__input');
    if (!first) return;
    if (!noteEl || !noteEl.isConnected) {
      noteEl = document.createElement('p');
      noteEl.className = 'abuba-bb-note';
      noteEl.setAttribute('data-abuba-bb-note', '');
      first.insertAdjacentElement('afterend', noteEl);
    }
    var sel = selected()[0];
    var text = sizeRequired ? 'Select a size to continue' : (sel ? sel.name + ' ' + sel.value + ' selected' : '');
    var hasTarget = !!document.getElementById('abuba-quick-size');
    var html = '<span class="abuba-bb-note__sel"></span>';
    if (hasTarget) html += '<a href="#abuba-quick-size">Check your size ↓</a>';
    /* B1 (2026-10-26): always point to the existing ABUBA Size Guide next to the size options. New tab, so the
       shopper's size/color choice on this page is kept and closing the tab brings them straight back. */
    html += '<a class="abuba-bb-guide" href="/pages/abuba-size-guide" target="_blank" rel="noopener" aria-label="How to measure your dog (ABUBA Size Guide, opens in a new tab)">How to measure →</a>';
    if (noteEl.getAttribute('data-sig') !== text + '|' + hasTarget) {
      noteEl.innerHTML = html;
      noteEl.querySelector('.abuba-bb-note__sel').textContent = text;
      noteEl.setAttribute('data-sig', text + '|' + hasTarget);
    }
  }

  // Availability hint. When the chosen pair is not a real variant (e.g. LITE2 XS + Pengi-Orange) the theme
  // only greys out the button. This says which sizes the chosen color does come in. It never changes the
  // customer's selection: size is fit-critical, so we do not switch it silently.
  var variantsP = null;
  var hintEl = null;

  function loadVariants() {
    if (!variantsP) {
      variantsP = fetch(window.location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p && p.variants ? p.variants : null; })
        .catch(function () { return null; });
    }
    return variantsP;
  }

  function setHint(text) {
    if (text) info.setAttribute('data-abuba-invalid', ''); else info.removeAttribute('data-abuba-invalid');
    if (!text) {
      if (hintEl && hintEl.isConnected) hintEl.remove();
      return;
    }
    var anchor = info.querySelector('variant-selects');
    if (!anchor) return;
    if (!hintEl || !hintEl.isConnected) {
      hintEl = document.createElement('p');
      hintEl.className = 'abuba-bb-note';
      hintEl.setAttribute('role', 'status');
      hintEl.setAttribute('data-abuba-bb-hint', '');
      anchor.insertAdjacentElement('afterend', hintEl);
    }
    if (hintEl.textContent !== text) hintEl.textContent = text;
  }

  function noteVariants(vs) {
    var min = Infinity, max = -Infinity;
    vs.forEach(function (v) { if (v.price < min) min = v.price; if (v.price > max) max = v.price; });
    if (min !== max) info.setAttribute('data-abuba-price-varies', ''); else info.removeAttribute('data-abuba-price-varies');
    /* a ?variant= that is not a real variant of this product does not count as a size choice */
    if (urlVariantId && !vs.some(function (v) { return String(v.id) === String(urlVariantId); }) && !sizeRequired && !sizeChosenByShopper) {
      sizeRequired = true; refresh();
    }
  }

  function checkHint() {
    var sel = selected();
    if (sizeRequired || sel.length < 2) { setHint(''); return; }
    loadVariants().then(function (vs) {
      if (!vs) { setHint(''); return; }
      noteVariants(vs);
      var cur = selected();
      if (cur.length < 2) { setHint(''); return; }
      var vals = cur.map(function (s) { return s.value; });
      var exists = vs.some(function (v) {
        return vals.every(function (val, i) { return v.options[i] === val; });
      });
      if (exists) { setHint(''); return; }
      var last = vals.length - 1;
      var offered = [];
      vs.forEach(function (v) {
        if (v.options[last] === vals[last] && offered.indexOf(v.options[0]) === -1) offered.push(v.options[0]);
      });
      if (!offered.length) { setHint(''); return; }
      var label = cur[0].name.toLowerCase();
      setHint(vals[last] + ' is not offered in ' + label + ' ' + vals[0] + '. Available ' + label + 's for ' + vals[last] + ': ' + offered.join(', ') + '.');
    });
  }

  function priceText() {
    var p = info.querySelector('.price .price-item--last') || info.querySelector('.price .price-item');
    return p ? p.textContent.trim() : '';
  }

  function syncSticky() {
    if (!sticky) return;
    var opts = sizeRequired ? SELECT_SIZE : selected().map(function (s) { return s.value; }).join(' · ');
    sticky.querySelector('[data-abuba-sticky-opts]').textContent = opts;
    var pt = priceText();
    if (info.hasAttribute('data-abuba-invalid')) pt = '';
    else if (sizeRequired && info.hasAttribute('data-abuba-price-varies')) pt = 'From ' + pt;
    sticky.querySelector('[data-abuba-sticky-price]').textContent = pt;
    var btn = mainBtn();
    var sb = sticky.querySelector('[data-abuba-sticky-btn]');
    if (btn) {
      var label = btn.querySelector('span') ? btn.querySelector('span').textContent.trim() : btn.textContent.trim();
      if (label) sb.textContent = label;
      sb.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
    }
  }

  function refresh() { applySizeRequired(); ensureNote(); checkHint(); syncSticky(); updateVisibility(); }

  var endZone = false;
  var typing = false; // hide the sticky bar while a [data-abuba-no-sticky] field has focus (mobile keyboard)
  document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest('[data-abuba-no-sticky]')) { typing = true; updateVisibility(); } });
  document.addEventListener('focusout', function (e) { if (e.target.closest && e.target.closest('[data-abuba-no-sticky]')) { typing = false; setTimeout(updateVisibility, 50); } });

  // Reads the CURRENT Add to Cart button each time: Dawn re-renders it on variant change, so an
  // observer bound to the first button would go stale.
  function atcOnScreen() {
    var b = mainBtn();
    if (!b) return true;
    var r = b.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  // The Final CTA band / footer may be below this script in the DOM, so query them live instead of at load.
  function endBandOnScreen() {
    var els = document.querySelectorAll('[data-abuba-final], footer, .footer');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight && r.bottom > 0) return true;
    }
    return false;
  }

  function updateVisibility() {
    if (!sticky) return;
    var show = window.scrollY > 240 && !atcOnScreen() && !endZone && !typing && !endBandOnScreen();
    sticky.setAttribute('data-visible', show ? 'true' : 'false');
  }

  if (sticky) {
    var btnProxy = sticky.querySelector('[data-abuba-sticky-btn]');
    btnProxy.addEventListener('click', function () {
      var b = mainBtn();
      if (b && !b.disabled) b.click();
      else info.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    if ('IntersectionObserver' in window) {
      var ends = document.querySelectorAll('[data-abuba-final], [data-abuba-placeholder="final"], footer, .footer');
      if (ends.length) {
        var seen = new Set();
        var eo = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
          endZone = seen.size > 0; updateVisibility();
        });
        ends.forEach(function (n) { eo.observe(n); });
      }
    }
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) {
      changeSeen = true;
      var g = sizeGroup();
      if (sizeRequired && g && g.contains(e.target)) { sizeRequired = false; sizeChosenByShopper = true; }
      setTimeout(refresh, 50);
    }
  });
  /* Picking the size that is already checked fires no change event, so give Dawn one. */
  document.addEventListener('click', function (e) {
    if (!sizeRequired || !e.target || !e.target.closest) return;
    var g = sizeGroup();
    if (!g || !g.contains(e.target)) return;
    if (!e.target.closest('label') && e.target.type !== 'radio') return;
    changeSeen = false;
    setTimeout(function () {
      if (!sizeRequired) return;
      sizeRequired = false; sizeChosenByShopper = true;
      var chosen = g.querySelector('input[type="radio"]:checked');
      info.removeAttribute('data-abuba-size-required');
      if (!changeSeen && chosen) chosen.dispatchEvent(new Event('change', { bubbles: true }));
      refresh();
    }, 0);
  }, true);
  var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(refresh, 60); });
  mo.observe(info, { childList: true, subtree: true, characterData: true });
  refresh();
  loadVariants().then(function (vs) { if (vs) { noteVariants(vs); refresh(); } });
})();
